import styled from '@emotion/styled';

export const RebatePercent = styled.div<{ isSelected?: boolean }>(({ isSelected, theme }) => ({
    fontSize: theme.fontSizes.xxs,
    marginRight: theme.space[1],
    fontWeight: theme.fontWeights.medium,
    textAlign: 'center',
    position: 'absolute',
    top: '-1px',
    left: '-1px',
    backgroundColor: isSelected === false ? theme.colors.grey40 : theme.colors.primaryTheme,
    color: theme.colors.white,
    padding: '1px 3px',
    borderBottomRightRadius: theme.general.borderRadius,
    borderTopLeftRadius: theme.general.borderRadius,
}));
